import { Routes, Route, Navigate } from "react-router-dom";
import * as routeConfig from "Infrastructure/config/routesConfig.js";
import routes from "./routes";
import PublicLayout from "./PublicLayout/index";

export default function PublicApp() {
  return (
    <PublicLayout>
      <Routes>
        {routes.map((element, index) => (
          <Route key={index} path={element.path} element={element.component} />
        ))}
        <Route
          path="*"
          element={<Navigate to={routeConfig.getRoute(routeConfig.LOGIN)} />}
        ></Route>
      </Routes>
    </PublicLayout>
  );
}
